// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mQuestionBottomWrap{width:100%;min-height:50px;display:flex;flex-direction:row;justify-content:space-around;align-items:center;background-color:#fff;border-radius:10px 10px 0 0;box-shadow:0 -4px 14px 0 #ccc;font-weight:700;position:fixed;bottom:0;left:50%;transform:translateX(-50%)}", ""]);
// Exports
module.exports = exports;
